export const BeautifulMentionAttribute = 'data-lexical-beautiful-mention-data';

export const extractPassportIds = (content: string): string[] => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');

  const idSet = new Set<string>();

  Array.from(doc.querySelectorAll(`[${BeautifulMentionAttribute}]`)).forEach(
    (el) => {
      const raw = el.getAttribute(BeautifulMentionAttribute);
      if (!raw) return;

      try {
        const data = JSON.parse(raw);
        if (data.id) {
          idSet.add(data.id);
        }
      } catch {
        // JSON 파싱 실패 시 무시
      }
    },
  );

  return Array.from(idSet);
};

/**
 * 멘션 노드 data JSON 에서 추린 멘션 객체. 부가 필드는 노드에 영속된 경우만 채워진다(optional).
 */
export type CommentMention = {
  id: string; // passportId
  name?: string;
  positionName?: string;
  departmentName?: string;
  divisionName?: string;
  companyName?: string;
  profileImageUrl?: string;
};

export const extractMentions = (content: string): CommentMention[] => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');

  const byId = new Map<string, CommentMention>();

  Array.from(doc.querySelectorAll(`[${BeautifulMentionAttribute}]`)).forEach(
    (el) => {
      const raw = el.getAttribute(BeautifulMentionAttribute);
      if (!raw) return;

      try {
        const data = JSON.parse(raw);
        const id: unknown = data?.id;
        if (typeof id !== 'string' || !id) return;
        if (byId.has(id)) return;

        byId.set(id, {
          id,
          name: typeof data.name === 'string' ? data.name : undefined,
          positionName:
            typeof data.positionName === 'string'
              ? data.positionName
              : undefined,
          departmentName:
            typeof data.departmentName === 'string'
              ? data.departmentName
              : undefined,
          divisionName:
            typeof data.divisionName === 'string'
              ? data.divisionName
              : undefined,
          companyName:
            typeof data.companyName === 'string' ? data.companyName : undefined,
          profileImageUrl:
            typeof data.profileImageUrl === 'string'
              ? data.profileImageUrl
              : undefined,
        });
      } catch {
        // JSON 파싱 실패 시 무시
      }
    },
  );

  return Array.from(byId.values());
};
